<template>
    <header>
        <el-menu mode="horizontal">
        <el-menu-item class="header-navicon" index="1">
            <el-button type="text" @click="openSidebar">
                <i class="el-icon-menu"></i>
            </el-button>
        </el-menu-item>
        <span class="header-title">{{title}}</span>
            <el-submenu class="header-menu" index="3">
                <template slot="title">
                    <img class="user-photo" :src='this.userPhoto' />
                </template>
                <el-menu-item index="4-1" @click="logOut">Logout</el-menu-item>
            </el-submenu>
        </el-menu>
    </header>
</template>

<script>
import Firebase from 'firebase';

export default {
  created() {
    const user = Firebase.auth().currentUser;
    this.userPhoto = user.photoURL;
  },
  name: 'Header',
  props: ['openSidebar', 'title'],
  data() {
    return {
      userPhoto: '',
    };
  },
  methods: {
    logOut() {
      Firebase.auth().signOut().then(() => {
        window.location.href = '/';
      }).catch((error) => {
        console.log(error);
      });
    },
  },
};
</script>

<style lang="scss">
header {
    z-index: 6;
    background: #fff;
    border-bottom: 1px solid $grey;
    box-shadow: inset 0 0 0 0 $grey,0 2px 1px 0 rgba(47,61,73,.05);
    color: #2e3d49;
    position: fixed;
    transform-style: preserve-3d;
    will-change: transform;
    transition-duration: .2s;
    transition-timing-function: cubic-bezier(.4,0,.2,1);
    transition-property: transform;
    width: 100%;
    height: $header-height;

    @include respond-to('sm', 'xs') {
        transform: translate3d(0, 0, 0)!important;
    }

    @include respond-to('lg') {
        width: calc(100% - #{$sidebar-size});
        transform: translate3d($sidebar-size, 0, 0)!important;
    }

    .el-menu {
        background-color: $header-bg-color;
        border-radius: 0;
    }

    .el-menu--horizontal>.el-submenu .el-submenu__title {
        color: $white;
    }
    .el-submenu__title i {
        color: $white;
    }
    .el-submenu:hover i {
        color: #000;
    }

    &.no_sidebar {
        transform: translate3d(0, 0, 0)!important;
        width: 100%;
    }

    .header-navicon {
        display: flex;
        align-items: center;
        align-content: center;
        @include respond-to('lg') {
            display: none;
        }
        i {
            color: $white!important;
            font-size: 2rem!important;
        }
    }
    .header-menu {
        float: right!important;
    }

    .header-title {
        font-size: 24px;
        color: $white;
        margin-left: 0;
        line-height: 60px;
        @include respond-to('lg') {
            margin-left: 24px;
        }
    }
    .user-photo {
        width: 50px;
        height: 50px;
        border-radius: 25px;
    }
}
</style>
